// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './vuex';
import router from './router';
import 'babel-polyfill';
import 'lib-flexible/flexible.js';
import infiniteScroll from 'vue-infinite-scroll';
import VueScroller from 'vue-scroller';
import globalInterval from './utils/Interval.js';
import EXIF from 'exif-js';
import axios from 'axios';
import Calendar from 'vue-mobile-calendar';
import 'swiper/dist/css/swiper.css';
import 'pdfh5/css/pdfh5.css';

import Mui from 'vue-awesome-mui';

import VueClipboard from 'vue-clipboard2';

// 开发时清除所有sessionStorage缓存
// sessionStorage.clear();

Vue.use(Mui);
Vue.use(Calendar);
Vue.use(VueScroller);
Vue.use(infiniteScroll);
Vue.use(VueClipboard);

Vue.config.productionTip = false;
Vue.prototype.globalInterval = globalInterval;
Vue.prototype.EXIF = EXIF;
Vue.prototype.$axios = axios;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js